import {Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges} from '@angular/core';
import {Question} from '../../models/question.model';

@Component({
  selector: 'app-skill-cp-custom',
  templateUrl: './skill-cp-custom.component.html'
})
export class SkillCpCustomComponent implements OnInit, OnChanges {
    @Input() question: Question;
    @Input() idx: number;
    @Input() data: any;
    @Input() totalApp: number;
    @Input() statistic: boolean;
    @Input() loopCount: number;
    @Input() isViewResult;
    @Input() checkControlPanel: any;
    @Output() getFull = new EventEmitter<any>();
    @Output() getFinal = new EventEmitter<any>();
    @Output() getValue = new EventEmitter();
    @Output() getAllResult = new EventEmitter();

    numberApp: number;
    lower: number = 1;
    upper: number = 7;
    min: number;
    max: number;
    content: number[];
    score: number = 0;
    idData: number;
    applicantsFulfill: number;

    constructor() { }

    ngOnInit() {
      if (this.checkControlPanel != null) {
        this.statistic = true;
      }
        for (let item of this.data) {
            if(item['question_id'] === this.question.id) {
                this.score = item['score'];
                this.idData = item['id'];
                this.applicantsFulfill = item['applicants_fulfill'];
                this.min = item['min'];
                this.max = item['max'];
                this.lower = this.getIndex(item['content'][0]);
                this.upper = this.getIndex(item['content'][item['content'].length -1]);

            }
        }
        this.getApplicantsSkill();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.loopCount && this.loopCount > 0) {
            this.getApplicantsSkill();
        }
    }

    onGetAllResult() {
        this.getAllResult.emit();
    }

    getApplicantsSkill() {
      this.numberApp = 0;
      this.content = [];
      const count = this.question.options.slice((this.lower - 1), this.upper);
      for(let item of count) {
        this.numberApp += item['count'];
        this.content.push(item.id);
      }
      let data = {
        id: this.idData,
        question_id: this.question.id,
        type: this.question.type,
        content: this.content,
        min: this.lower,
        max: this.upper,
        score: this.score,
        applicants_fulfill: this.numberApp,
        options: this.question.options
      };
      if (typeof this.data !== 'undefined' && this.data.length > 0) {
        for (let item of this.data) {
          if(item['question_id'] === this.question.id) {
            data.id = item['id'];
          }
        }
      }
      if (this.score < 0 ) {
        this.score = 0;
      }
      if (this.score > 99) {
        this.score = 99;
      }

      this.getFull.emit(data);
    }

    getIndex(value: any) {
        for(let i = 0; i < this.question.options.length; i++) {
            if(this.question.options[i].id == value) {
                return i + 1;
            }
        }
    }
}
